import appConfig from '@/features/app/constants/app-config';
import cookieConsentConfigurations from '@/features/app/constants/cookie-consent-configurations';

export default function getSavedCookieConsentSetting(): { [key: string]: boolean | undefined } {
  const savedConsentSettings = localStorage.getItem(appConfig.cookieConsentKey);
  const cookieSettings: { [key: string]: boolean | undefined } = {};

  if (savedConsentSettings) {
    try {
      const parsedSettings = JSON.parse(savedConsentSettings);
      for (const cookieGroup of cookieConsentConfigurations) {
        for (const subCookie of cookieGroup.cookies) {
          if (subCookie.required) {
            cookieSettings[subCookie.id] = true;
          } else if (typeof parsedSettings[subCookie.id] === 'boolean') {
            cookieSettings[subCookie.id] = parsedSettings[subCookie.id];
          }
        }
      }
    } catch (e) {
      return {};
    }
  }

  return cookieSettings;
}
